import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function MinnestroneSoup() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Minnestrone Soup</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>3 large carrots,
        roughly chopped<br></br>1 large onion, roughly chopped<br></br>4 celery
        sticks, roughly chopped<br></br>1 tbsp olive oil<br></br>2 garlic
        cloves, crushed<br></br>2 large potatoes, cut into small dice<br></br>2
        tbsp tomato purée<br></br>
        2l vegetable stock<br></br>
        400g can chopped tomatoes<br></br>
        400g can butter or cannellini beans<br></br>
        140g spaghetti, snapped into short lengths<br></br>½ head Savoy cabbage,
        shredded<br></br>
        crusty bread, to serve<br></br>
      </Typography>

      <Typography>
        In a food processor, whizz the carrots, onion and celery into small
        pieces. Heat the oil in a pan, add the processed vegetables, garlic and
        potatoes, then cook over a high heat for 5 mins until softened.<br></br>
        Stir in the tomato purée, stock and tomatoes. Bring to the boil, then
        turn down the heat and simmer, covered, for 10 mins.<br></br>
        Tip in the beans and pasta, then cook for a further 10 mins, adding the
        cabbage for the final 2 mins. Season to taste and serve with crusty
        bread.<br></br>
      </Typography>
    </Card>
  );
}
